<template>
	<div class="tc-ghost-schedule"
		v-bind:style="styleGhostSchedule"
		v-if="showGhostSchedule"
	>
		<div class="schedule"></div>
	</div>
</template>
<script>
import ScheduleListRow from '../../classes/ScheduleListRow';
import clonedeep from 'lodash/cloneDeep';

export default {
	name: 'TCGhostSchedule',
	props: [
		"ghost_schedule",
		"item",
	],
	computed: {
		showGhostSchedule: function() {
			if (this.ghost_schedule === undefined || this.ghost_schedule === null)
				return false;
			
			if(this.$store.getters['chart/isDisplayMemberList']) {
				if (this.item.item_type === ScheduleListRow.ITEM_TYPE.MEMBER) {
					if(this.ghost_schedule.member_code === this.item.code)
						return true;
				} else {
					if(this.ghost_schedule.task_code === this.item.code)
						return true;
				}
			} else {
				if (this.item.item_type === ScheduleListRow.ITEM_TYPE.PROJECT && this.ghost_schedule.task_code === '') {
					if (this.ghost_schedule.project_code === this.item.code)
						return true;
				} else if (this.item.item_type === ScheduleListRow.ITEM_TYPE.TASK) {
					if (this.ghost_schedule.task_code === this.item.code && this.ghost_schedule.project_code === this.item.project_code)
						return true;
				}
			}
			return false;
		},
		styleGhostSchedule: function() {
			let source_begin = this.$store.getters.createDateCurrentBeginningDay;
			let source_end = clonedeep(source_begin);
			source_end.setHours(source_end.getHours() + 24);
			let begin_as_minutes = this.ghost_schedule.begin.getDiffFromDateAsMinutes(source_begin);
			let end_as_minutes = this.ghost_schedule.end.getDiffFromDateAsMinutes(source_end) + (24 * 60);
			
			return {
				"left": (this.$store.getters['chart/computeWidthFromMinutes'](begin_as_minutes)) + "px",
				"width": (this.$store.getters['chart/computeWidthFromMinutes'](end_as_minutes - begin_as_minutes)) + 'px',
			};
		},
	},
};
</script>
<style>
	.tc-ghost-schedule {
		display: inline-block;
		margin-top: 18px;
		height: 27px;
		position: absolute;
		border-radius: 13px;
		border-style: none;
		text-align: center;
	}
	.tc-ghost-schedule .schedule {
		position: absolute;
		height: 100%;
		width:100%;
		opacity: .5;
		border: dotted 3px rgba(0, 0, 0, .5);
		background-color: white;
	}
</style>
